import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "IRS_STATE_REJECTED/STATE_RESUBMIT";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setFormList: (state, action) => {
            state.formList = action.payload;
        },

        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },

        setPayerList: (state, action) => {
            state.payerList = action.payload;
        },

        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },

        setTaxYearList: (state, action) => {
            state.taxYearList = action.payload;
        },

        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },

        setStateResubmitGridData: (state, action) => {
            state.stateResubmitGridData = action.payload;
        },

        setSelectedStateResubmitGridData: (state, action) => {
            state.selectedStateResubmitGridData = action.payload;
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        setUpdateWithheldIdModal: (state, action) => {
            state.updateWithheldIdModal = action.payload;
        },

        setWithheldIdText: (state, action) => {
            state.withheldIdText = action.payload;
        },

        setSelectedStateReference: (state, action) => {
            state.selectedStateReference = action.payload;
        },

        setDownloadAllPdfModal: (state, action) => {
            state.downloadAllPdfModal = action.payload;
        },

        setReloadResubmitGridData: (state, action) => {
            state.reloadResubmitGridData = action.payload;
        },

        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

        //Filters
        formList: [],
        selectedForm: { label: "", value: "" },

        payerList: [],
        selectedPayer: { label: "", value: "" },

        taxYearList: [],
        selectedTaxYear: { label: "", value: "" },

        //Grid
        stateResubmitGridData: [],
        selectedStateResubmitGridData: [],

        withheldIdText: "",
        selectedStateReference: {},

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            SearchByTIN: "",
            SearchByName: "",
            IsDesc: true,
            Skip: 0,
            total: 10,
        },

        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },

        //Modals
        updateWithheldIdModal: false,
        downloadAllPdfModal: false,
        reloadResubmitGridData: false,
    }
})

export const { setLoadingState, setFormList, setSelectedForm, setPayerList, setSelectedPayer, setTaxYearList, setSelectedTaxYear, setStateResubmitGridData, setSelectedStateResubmitGridData, setPaginationState, setUpdateWithheldIdModal, setWithheldIdText, setSelectedStateReference, setDownloadAllPdfModal, setReloadResubmitGridData, setPayerDropdownPagination } = actions; 
